// Footer.jsx
import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

export const Footer = () => {
    const footerStyles = {
        footer: {
            backgroundColor: 'var(--white-off)',
            borderTop: '3px solid var(--saffron-deep)',
            padding: '3rem 0 1.5rem',
            marginTop: '3rem'
        },
        heading: {
            color: 'var(--saffron-dark)',
            fontWeight: 600,
            fontSize: '1.2rem',
            marginBottom: '1rem',
            borderLeft: '4px solid var(--saffron-deep)',
            paddingLeft: '0.8rem'
        },
        contactInfo: {
            color: '#2c2c2c',
            fontSize: '0.95rem',
            marginBottom: '0.5rem',
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem'
        },
        iconStyle: {
            color: 'var(--saffron-deep)',
            width: '20px',
            fontSize: '1rem'
        },
        socialIcon: {
            color: 'var(--saffron-deep)',
            fontSize: '1.5rem',
            marginRight: '1rem',
            transition: '0.2s',
            cursor: 'pointer'
        },
        copyright: {
            textAlign: 'center',
            marginTop: '2rem',
            paddingTop: '1.5rem',
            borderTop: '1px solid var(--saffron-light)',
            color: '#4f4f4f',
            fontSize: '0.9rem'
        },
        badge: {
            backgroundColor: 'var(--saffron-soft)',
            padding: '0.3rem 1rem',
            borderRadius: '20px',
            color: 'var(--saffron-dark)',
            fontSize: '0.9rem',
            display: 'inline-block',
            border: '1px solid var(--saffron-light)'
        }
    };

    const handleSocialHover = (e, isHover) => {
        e.target.style.color = isHover ? 'var(--saffron-dark)' : 'var(--saffron-deep)';
    };

    return (
        <footer style={footerStyles.footer}>
            <Container>
                <Row>
                    <Col lg={4} md={6} className="mb-4">
                        <h5 style={footerStyles.heading}>संपर्क करें</h5>
                        <div style={footerStyles.contactInfo}>
                            <i className="fas fa-map-marker-alt" style={footerStyles.iconStyle}></i>
                            <span>बरवर नगर पंचायत, जनपद - खीरी (उत्तर प्रदेश)</span>
                        </div>
                        <div style={footerStyles.contactInfo}>
                            <i className="fas fa-phone-alt" style={footerStyles.iconStyle}></i>
                            <span>7565838125</span>
                        </div>
                        <div style={footerStyles.contactInfo}>
                            <i className="fas fa-envelope" style={footerStyles.iconStyle}></i>
                            <span>awashthisonamsharma@gmail.com</span>
                        </div>
                    </Col>

                    <Col lg={4} md={6} className="mb-4">
                        <h5 style={footerStyles.heading}>जनता दरबार</h5>
                        <div style={footerStyles.contactInfo}>
                            <i className="fas fa-clock" style={footerStyles.iconStyle}></i>
                            <span>प्रतिदिन शाम 7:00 बजे से रात 10:00 बजे तक</span>
                        </div>
                        <div style={footerStyles.contactInfo}>
                            <i className="fas fa-location-dot" style={footerStyles.iconStyle}></i>
                            <span>बरवर नगर पंचायत</span>
                        </div>
                        <div style={{ ...footerStyles.contactInfo, fontStyle: 'italic', marginTop: '0.5rem' }}>
                            <i className="fas fa-quote-right" style={footerStyles.iconStyle}></i>
                            <span>"समस्या आपकी, संघर्ष मेरा"</span>
                        </div>
                    </Col>

                    <Col lg={4} md={6} className="mb-4">
                        <h5 style={footerStyles.heading}>हमसे जुड़ें</h5>
                        <div>
                            <a
                                href="https://www.facebook.com/share/18P9DLJgLZ/"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ textDecoration: 'none', margin: '0 8px', display: 'inline-block' }}
                            >
                                <i
                                    className="fab fa-facebook-f"
                                    style={footerStyles.socialIcon}
                                    onMouseEnter={(e) => handleSocialHover(e, true)}
                                    onMouseLeave={(e) => handleSocialHover(e, false)}
                                ></i>
                            </a>

                            <a
                                href="https://twitter.com"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ textDecoration: 'none', margin: '0 8px', display: 'inline-block' }}
                            >
                                <i
                                    className="fab fa-twitter"
                                    style={footerStyles.socialIcon}
                                    onMouseEnter={(e) => handleSocialHover(e, true)}
                                    onMouseLeave={(e) => handleSocialHover(e, false)}
                                ></i>
                            </a>

                            <a
                                href="https://www.instagram.com/chhatrapati_sharma_ji?utm_source=qr&igsh=MWR4NXZncnlpMDc4OA=="
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ textDecoration: 'none', margin: '0 8px', display: 'inline-block' }}
                            >
                                <i
                                    className="fab fa-instagram"
                                    style={footerStyles.socialIcon}
                                    onMouseEnter={(e) => handleSocialHover(e, true)}
                                    onMouseLeave={(e) => handleSocialHover(e, false)}
                                ></i>
                            </a>

                            <a
                                href="https://youtube.com"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ textDecoration: 'none', margin: '0 8px', display: 'inline-block' }}
                            >
                                <i
                                    className="fab fa-youtube"
                                    style={footerStyles.socialIcon}
                                    onMouseEnter={(e) => handleSocialHover(e, true)}
                                    onMouseLeave={(e) => handleSocialHover(e, false)}
                                ></i>
                            </a>
                        </div>
                        <div style={{ marginTop: '1.5rem' }}>
                            <span style={footerStyles.badge}>
                                <i className="fas fa-map-pin me-1"></i> 144 विधानसभा, मोहम्मदी (खीरी)
                            </span>
                        </div>
                    </Col>
                </Row>

                <div style={footerStyles.copyright}>
                    <i className="fas fa-lotus me-2" style={{ color: 'var(--saffron-deep)' }}></i>
                    © 2026 पंडित धीरेंद्र कुमार शर्मा | सर्वाधिकार सुरक्षित
                    <div style={{ marginTop: '0.5rem', color: 'var(--saffron-deep)' }}>
                        स्वतंत्रता सेनानी की विरासत और सनातनी गौरव
                    </div>
                </div>
            </Container>
        </footer>
    );
};

export default Footer;